import React, { lazy } from "react";
import { useRoutes } from "react-router-dom";
import {
  PRODUCTCODES_JOBPORTAL,
  PRODUCTCODES_UPUBLISHME,
  PRODUCTCODES_URTECHCITY,
  PRODUCTCODES_URTECHPOGO,
  PRODUCTCODES_URTECHPOS,
  PRODUCTCODES_URTECHSHOP,
} from "@genericComponents/CFW.js";
import { User } from "@genericComponents/User.js";
const useProductLanguageCode =
  await import("@customHooks/useProductLanguageCode.js").then(
    (mod) => mod.useProductLanguageCode,
  );
const RetrieveClientProfile = lazy(
  () => import("@apicontrols/RetrieveClientProfile.js"),
);
const Home = lazy(() => import("@home/page.js"));
const ProductList = lazy(() => import("@controls/ProductList.js"));
const LinkedInCallBack = lazy(
  () => import("@components/LinkedInCallBack/page.js"),
);
const AddPoints = lazy(() => import("@components/AddPoints/page.js"));
const AdsenseEarnings = lazy(
  () => import("@components/AdsenseEarnings/page.js"),
);
const Categories = lazy(() => import("@components/Categories/page.js"));
const ClientProfile = lazy(() => import("@components/ClientProfile/page.js"));
const CompanyProfile = lazy(() => import("@components/CompanyProfile/page.js"));
const ConfirmPayment = lazy(() => import("@components/ConfirmPayment/page.js"));
const ContactUs = lazy(() => import("@components/ContactUs/page.js"));
const EmailBlaster = lazy(() => import("@components/EmailBlaster/page.js"));
const Employees = lazy(() => import("@components/Employees/page.js"));
const OurServicesList = lazy(
  () => import("@components/Home/OurServicesList.js"),
);
const MaintainPayment = lazy(
  () => import("@components/MaintainPayment/page.js"),
);
const Messages = lazy(() => import("@components/Messages/page.js"));
const NoMatch = lazy(() => import("@components/NoMatch/page.js"));
const OurClients = lazy(() => import("@components/OurClients/page.js"));
const OurPeople = lazy(() => import("@components/OurPeople/page.js"));
const Payments = lazy(() => import("@components/Payments/page.js"));
const PrivacyPolicy = lazy(() => import("@components/PrivacyPolicy/page.js"));
const ResetPassword = lazy(() => import("@components/ResetPassword/page.js"));
const Services = lazy(() => import("@components/Services/page.js"));
const TranslationType = lazy(
  () => import("@views/Company/TranslationType/page.js"),
);
const UserGuide = lazy(() => import("@components/UserGuide/page.js"));
const Banners = lazy(() => import("@views/Company/Banners/page.js"));
const ClientLogos = lazy(() => import("@views/Company/ClientLogos/page.js"));
const DynamicOptionType = lazy(
  () => import("@views/Company/DynamicOptionType/page.js"),
);
const DynamicOptions = lazy(
  () => import("@views/Company/DynamicOptions/page.js"),
);
const OurServices = lazy(() => import("@views/Company/OurServices/page.js"));
const Products = lazy(() => import("@views/Company/Products/page.js"));
const RecommendUsList = lazy(
  () => import("@views/Company/RecommendUsList/page.js"),
);
const SiteMap = lazy(() => import("@views/Company/SiteMap/page.js"));
const UserStatusRole = lazy(
  () => import("@views/Company/UserStatusRole/page.js"),
);
const DailyTimeRecord = lazy(
  () => import("@views/JobPortal/DailyTimeRecord/page.js"),
);
const Education = lazy(() => import("@views/JobPortal/Education/page.js"));
const EmployeeTaskLog = lazy(
  () => import("@views/JobPortal/EmployeeTaskLog/page.js"),
);
const FindJobs = lazy(() => import("@views/JobPortal/FindJobs/page.js"));
const FindProfile = lazy(() => import("@views/JobPortal/FindProfile/page.js"));
const JobProfile = lazy(() => import("@views/JobPortal/JobProfile/page.js"));
const JobsApplied = lazy(() => import("@views/JobPortal/JobsApplied/page.js"));
const OtherCredentials = lazy(
  () => import("@views/JobPortal/OtherCredentials/page.js"),
);
const Portfolios = lazy(() => import("@views/JobPortal/Portfolios/page.js"));
const JobPostsSkills = lazy(
  () => import("@views/JobPortal/PostJobs/jobPostsSkills.js"),
);
const PostJobs = lazy(() => import("@views/JobPortal/PostJobs/page.js"));
const TaskLog = lazy(() => import("@views/JobPortal/TaskLog/page.js"));
const UserLanguage = lazy(
  () => import("@views/JobPortal/UserLanguage/page.js"),
);
const UserSkills = lazy(() => import("@views/JobPortal/UserSkills/page.js"));
const ViewBusinessProfile = lazy(
  () => import("@views/JobPortal/ViewBusinessProfile/page.js"),
);
const ViewJobPost = lazy(() => import("@views/JobPortal/ViewJobPost/page.js"));
const ViewMyCV = lazy(() => import("@views/JobPortal/ViewMyCV/page.js"));
const WorkExperience = lazy(
  () => import("@views/JobPortal/WorkExperience/page.js"),
);
const LotCart = lazy(() => import("@views/POGO/LotCart/page.js"));
const LotPayments = lazy(() => import("@views/POGO/LotPayments/page.js"));
const LotteryGameList = lazy(
  () => import("@views/POGO/LotteryGameList/page.js"),
);
const MaintainLotDraw = lazy(
  () => import("@views/POGO/MaintainLotDraw/page.js"),
);
const MaintainLotteryGames = lazy(
  () => import("@views/POGO/MaintainLotteryGames/page.js"),
);
const Expenses = lazy(() => import("@views/POS/Expenses/page.js"));
const Inventory = lazy(() => import("@views/POS/Inventory/page.js"));
const Items = lazy(() => import("@views/POS/Items/page.js"));
const MyCart = lazy(() => import("@views/POS/MyCart/page.js"));
const POS = lazy(() => import("@views/POS/POS/page.js"));
const Packages = lazy(() => import("@views/POS/Packages/page.js"));
const ResellerPackageItems = lazy(
  () => import("@views/POS/ResellerPackageItems/page.js"),
);
const Sales = lazy(() => import("@views/POS/Sales/page.js"));
const Suppliers = lazy(() => import("@views/POS/Suppliers/page.js"));
const ViewItem = lazy(() => import("@views/POS/ViewItem/page.js"));
const ViewOrder = lazy(() => import("@views/POS/ViewOrder/page.js"));
const SearchShops = lazy(() => import("@views/Shopper/SearchShops/page.js"));
const FindContent = lazy(() => import("@views/UPublishMe/FindContent/page.js"));
const MaintainAllContents = lazy(
  () => import("@views/UPublishMe/MaintainAllContents/page.js"),
);
const MaintainMarketingVideos = lazy(
  () => import("@views/Company/MaintainMarketingVideos/page.js"),
);
const MaintainContents = lazy(
  () => import("@views/UPublishMe/MaintainContents/page.js"),
);
const ViewContent = lazy(() => import("@views/UPublishMe/ViewContent/page.js"));
const SignIn = lazy(() => import("@components/SignIn/page.js"));
const UpdateProfile = lazy(() => import("@components/UpdateProfile/page.js"));
const NoClientProfilePreventWindow = lazy(
  () => import("@apicontrols/NoClientProfilePreventWindow.js"),
);
const ConstructPath = await import("@asyncImports/ConstructPath.js").then(
  (mod) => mod.ConstructPath,
);
const PageSelector = ({ roles }) => {
  const { languageCode, productCode } = useProductLanguageCode();
  const collectedRoutes = [
    {
      path: ConstructPath(
        languageCode,
        productCode,
        "auth/linkedin/callback",
        true,
      ),
      element: <LinkedInCallBack />,
    },
  ];
  const getRouter = (paramPath, paramElement) => {
    let param = productCode.toLowerCase();
    if (paramPath === "*") {
      collectedRoutes.push({ path: paramPath, element: paramElement });
    } else {
      [
        `/${paramPath}`,
        `/${languageCode}/${paramPath}`,
        `/${param}/${paramPath}`,
        `/${param}/${languageCode}/${paramPath}`,
      ].forEach((urlLink) => {
        collectedRoutes.push({ path: urlLink, element: paramElement });
      });
    }
  };
  getRouter("signin", <SignIn />);
  getRouter("", <Home />);
  getRouter("Home", <Home />);
  getRouter("resetpassword", <ResetPassword />);
  getRouter("companyprofile", <CompanyProfile />);
  getRouter("privacypolicy", <PrivacyPolicy />);
  getRouter("ourclients", <OurClients />);
  getRouter("ourpeople", <OurPeople />);
  getRouter("contactus", <ContactUs />);
  getRouter("services/:serviceId", <Services />);
  getRouter("ourserviceslist", <OurServicesList />);
  getRouter("productlist", <ProductList />);
  getRouter("UserGuide", <UserGuide />);
  getRouter("message", <Messages />);
  getRouter("updateprofile", <UpdateProfile />);
  getRouter("Categories/:categoryId", <Categories />);
  getRouter("ViewItem/:ResellerPackageItemGUID", <ViewItem />);
  getRouter("ViewBusinessProfile/:clientid", <ViewBusinessProfile />);
  if (productCode === PRODUCTCODES_URTECHCITY && User.IsTranslator(roles)) {
    getRouter("TranslationType", <TranslationType />);
  }
  if (productCode === PRODUCTCODES_URTECHCITY && User.IsSuperAdmin(roles)) {
    getRouter("MaintainMarketingVideos", <MaintainMarketingVideos />);
    getRouter("SiteMap", <SiteMap />);
  }
  if (User.IsSuperAdmin(roles) || User.IsAdmin(roles)) {
    getRouter("EmailBlaster", <EmailBlaster />);
  }
  if (
    User.IsSuperAdmin(roles) ||
    User.IsAgency(roles) ||
    User.IsAdmin(roles) ||
    User.IsCompanyOwner(roles)
  ) {
    getRouter("ClientProfile", <ClientProfile />);
  }
  if (User.IsCompanyOwner(roles) || User.IsAgency(roles)) {
    getRouter(
      "Employees",
      <NoClientProfilePreventWindow>
        <Employees />
      </NoClientProfilePreventWindow>,
    );
  }
  if (
    productCode === PRODUCTCODES_URTECHCITY &&
    (User.IsAdmin(roles) || User.IsSuperAdmin(roles))
  ) {
    getRouter("banners", <Banners />);
    getRouter("clientLogos", <ClientLogos />);
    getRouter("DynamicOptionType", <DynamicOptionType />);
    getRouter("DynamicOptions", <DynamicOptions />);
    getRouter("OurServices", <OurServices />);
    getRouter("Products", <Products />);
    getRouter("UserStatusRole", <UserStatusRole />);
  }
  if (
    productCode === PRODUCTCODES_URTECHPOS &&
    (User.IsAdmin(roles) || User.IsAgency(roles) || User.IsCompanyOwner(roles))
  ) {
    getRouter(
      "Suppliers",
      <NoClientProfilePreventWindow>
        <Suppliers />
      </NoClientProfilePreventWindow>,
    );
    getRouter(
      "Items",
      <NoClientProfilePreventWindow>
        <Items />
      </NoClientProfilePreventWindow>,
    );
    getRouter(
      "Inventory",
      <NoClientProfilePreventWindow>
        <Inventory />
      </NoClientProfilePreventWindow>,
    );
    getRouter(
      "Packages",
      <NoClientProfilePreventWindow>
        <Packages />
      </NoClientProfilePreventWindow>,
    );
    getRouter(
      "Expenses",
      <NoClientProfilePreventWindow>
        <Expenses />
      </NoClientProfilePreventWindow>,
    );
    getRouter(
      "Sales",
      <NoClientProfilePreventWindow>
        <Sales />
      </NoClientProfilePreventWindow>,
    );
  }
  if (productCode === PRODUCTCODES_URTECHPOS && User.IsReseller(roles)) {
    getRouter("ResellerPackageItems", <ResellerPackageItems />);
  }
  if (
    (productCode === PRODUCTCODES_URTECHPOS ||
      productCode === PRODUCTCODES_URTECHSHOP) &&
    User.IsReseller(roles)
  ) {
    getRouter("ViewOrder", <ViewOrder />);
  }
  if (
    productCode === PRODUCTCODES_URTECHPOS &&
    (User.IsTeamLeader(roles) ||
      User.IsAdmin(roles) ||
      User.IsAgency(roles) ||
      User.IsCompanyOwner(roles))
  ) {
    getRouter(
      "POS",
      <NoClientProfilePreventWindow>
        <POS />
      </NoClientProfilePreventWindow>,
    );
  }
  if (User.IsLoggedIn(roles)) {
    getRouter("RecommendUsList", <RecommendUsList />);
    getRouter("MyCart", <MyCart />);
    getRouter("Payments", <Payments />);
    getRouter(
      "AddPoints",
      <AddPoints productCode={productCode} languageCode={languageCode} />,
    );
    getRouter("ConfirmPayment/:paymentTypeId", <ConfirmPayment />);
    getRouter(
      "DailyTimeRecord/:clientId",
      <NoClientProfilePreventWindow>
        <DailyTimeRecord
          languageCode={languageCode}
          productCode={productCode}
        />
      </NoClientProfilePreventWindow>,
    );
    getRouter(
      "DailyTimeRecord",
      <NoClientProfilePreventWindow>
        <DailyTimeRecord
          languageCode={languageCode}
          productCode={productCode}
        />
      </NoClientProfilePreventWindow>,
    );
    getRouter("AdsenseEarnings", <AdsenseEarnings />);
  }
  if (productCode === PRODUCTCODES_UPUBLISHME) {
    getRouter("FindContent/:categoryId", <FindContent />);
    getRouter("FindContent", <FindContent />);
    getRouter("ViewContent/:contentGUID", <ViewContent />);
    if (User.IsLoggedIn(roles)) {
      getRouter("MaintainContents", <MaintainContents />);
    }
  }
  if (productCode === PRODUCTCODES_UPUBLISHME && User.IsSuperAdmin(roles)) {
    getRouter("MaintainAllContents", <MaintainAllContents />);
  }
  if (User.IsSuperAdmin(roles)) {
    getRouter("MaintainPayment", <MaintainPayment />);
  }
  if (
    productCode === PRODUCTCODES_JOBPORTAL &&
    User.IsLoggedIn(roles) &&
    (User.IsNormalUser(roles) || User.IsTeamLeader(roles))
  ) {
    getRouter("JobProfile", <JobProfile />);
    getRouter("UserSkills", <UserSkills />);
    getRouter("UserLanguage", <UserLanguage />);
    getRouter("Portfolios", <Portfolios />);
    getRouter("OtherCredentials", <OtherCredentials />);
    getRouter("Education", <Education />);
    getRouter("JobsApplied", <JobsApplied />);
    getRouter("WorkExperience", <WorkExperience />);
    getRouter(
      "TaskLog",
      <RetrieveClientProfile showChildrenIfNotExists={true}>
        <TaskLog languageCode={languageCode} />
      </RetrieveClientProfile>,
    );
  }
  if (productCode === PRODUCTCODES_JOBPORTAL) {
    getRouter("ViewMyCV/:userguid", <ViewMyCV />);
    getRouter("ViewJobPost/:postId", <ViewJobPost />);
    getRouter("FindJobs", <FindJobs />);
    getRouter("JobProfile", <JobProfile />);
  }
  if (
    productCode === PRODUCTCODES_JOBPORTAL &&
    (User.IsCompanyOwner(roles) || User.IsAgency(roles))
  ) {
    getRouter(
      "PostJobs",
      <RetrieveClientProfile showChildrenIfNotExists={true}>
        <PostJobs />
      </RetrieveClientProfile>,
    );
    getRouter("JobPostsSkills/:postId", <JobPostsSkills />);
    getRouter(
      "FindProfile",
      <RetrieveClientProfile showChildrenIfNotExists={true}>
        <FindProfile />
      </RetrieveClientProfile>,
    );
    getRouter(
      "EmployeeTaskLog",
      <RetrieveClientProfile showChildrenIfNotExists={true}>
        <EmployeeTaskLog
          languageCode={languageCode}
          productCode={productCode}
        />
      </RetrieveClientProfile>,
    );
  }
  if (productCode === PRODUCTCODES_URTECHSHOP) {
    getRouter("SearchShops", <SearchShops />);
  }
  if (productCode === PRODUCTCODES_URTECHPOGO && User.IsSuperAdmin(roles)) {
    getRouter("MaintainLotteryGames", <MaintainLotteryGames />);
    getRouter("MaintainLotDraw", <MaintainLotDraw />);
  }
  if (productCode === PRODUCTCODES_URTECHPOGO) {
    getRouter("LotCart", <LotCart />);
    getRouter("LotPayments", <LotPayments />);
    getRouter("LotteryGameList/:countryid", <LotteryGameList />);
  }
  getRouter("*", <NoMatch />);
  const RouteCollection = () => useRoutes(collectedRoutes);
  return <RouteCollection />;
};
export default PageSelector;
